import type { ReactNode } from 'react'

import { Box } from '@/components/Box/Box'

import { doisters } from './doister-avatars'

import css from './inline-avatar-stack.module.css'
import { Avatar } from '@/components/avatar/avatar'

type InlineAvatarStackProps = { children: ReactNode }

type InlineAvatarProps = {
    src?: string
    doister?: keyof typeof doisters
    size?: number
}

function InlineAvatarStack({ children }: InlineAvatarStackProps) {
    return (
        <Box tag="span" aria-hidden="true" className={css.avatarStack} data-nosnippet>
            {children}
        </Box>
    )
}

InlineAvatarStack.Avatar = ({ src, doister = 'amir', size = 24 }: InlineAvatarProps) => {
    const imgURL = src || doisters[doister]

    if (!imgURL) return null

    return <Avatar className={css.inlineAvatar} tag="span" size={size} src={imgURL} alt="" />
}

export { InlineAvatarStack }
export type { InlineAvatarProps, InlineAvatarStackProps }
